import CalculateOutlinedIcon from "@mui/icons-material/CalculateOutlined";
import Grid from "@mui/material/Grid";

const CustomConsumptionCell = ({ rowObj, funcs }) => {
	const cellCenterLabel = rowObj.consumption == null ? "" : rowObj.consumption.toString();

	const cellCenter = (
		<div className="TableCell" clm="consumption" style={{ display: "flex", justifyContent: "center" }}>
			{cellCenterLabel}
		</div>
	);

	let cellLeft = <></>;
	let cellRight = <></>;
	let cellFormula = <></>;

	if (rowObj?.rowHeightMultiply != null) {
		cellFormula = (
			<span style={{ fontSize: "10px", color: "var(--tree-row-valid)", display: "flex", width: "100%", justifyContent: "center" }}>
				{rowObj.quantityformula}
			</span>
		);
	}

	if (rowObj.quantityformula) {
		cellRight = (
			<div className="TreeActionCell" title={rowObj.quantityformula} onClick={(e) => funcs.showSourceCostFormulas(rowObj, e)}>
				<CalculateOutlinedIcon style={{ fontSize: "13px", position: "relative", top: "1px" }} />
			</div>
		);
		return (
			<td
				key={`cell-consumption-${rowObj.key}`}
				className="TableCell"
				clm="consumption"
				treecell="false"
				style={{
					paddingLeft: "5px",
				}}
				title={cellCenterLabel}
			>
				<Grid container mb={0} spacing={0} justifyContent="center" alignItems="center">
					<Grid item xs={2}>
						{cellLeft}
					</Grid>
					<Grid item xs={8}>
						{cellCenter}
					</Grid>
					<Grid item xs={2}>
						{cellRight}
					</Grid>
				</Grid>
				{cellFormula}
			</td>
		);
	} else {
		return (
			<td
				key={`cell-consumption-${rowObj.key}`}
				className="TableCell"
				clm="consumption"
				treecell="false"
				title={cellCenterLabel}
				style={{ textAlign: "center" }}
			>
				{cellCenterLabel}
			</td>
		);
	}
};

export default CustomConsumptionCell;
